/**
 * Unified Statistics Component
 * Consistent statistics cards for all management pages
 */

import React from 'react';
import './UnifiedStats.css';

const UnifiedStats = ({ stats, className = '' }) => {
    return (
        <div className={`unified-stats-grid ${className}`}>
            {stats.map((stat, index) => (
                <div key={index} className="unified-stat-card">
                    <h3>{stat.title}</h3>
                    <p className="unified-stat-number">{stat.value}</p>
                    {stat.subtitle && (
                        <p className="unified-stat-subtitle">{stat.subtitle}</p>
                    )}
                </div>
            ))}
        </div>
    );
};

export default UnifiedStats;
